import axios from "axios";
import { makeAutoObservable, toJS } from "mobx";
import Tool from "../pages/ROI/Tool";
import ToolStore from "./ToolStore";

class WorkflowStore {
  defaultsValues = {};
  data = {};
  changed = {};
  reset() {
    this.defaultsValues = {};
    this.data = {};
    this.changed = {};
  }
  constructor() {
    makeAutoObservable(this);
  }

  setDefaultsValues() {
    this.defaultsValues = this.toFormatJson();
  }
  getData() {
    return toJS(this.data);
  }

  setData(values) {
    this.data = values;
  }
  setChanged(values) {
    this.changed = values;
  }

  setChangedFirst(values) {
    this.changed = values;
  }
  toFormatChanged() {
    var json = {};
    toJS(this.data)[0].value.forEach((x) => {
      if (Array.isArray(x.value)) {
        x.value.forEach((y) => {
          if (Array.isArray(y.value)) {
            y.value.forEach((z) => {
              json[x.fieldName + "" + y.fieldName + z.fieldName] = false;
            });
          } else {
            json[x.fieldName + "" + y.fieldName] = false;
          }
        });
      } else {
        json[x.fieldName] = false;
      }
    });

    return json;
  }
  toFormatJson() {
    var json = {};
    toJS(this.data)[0].value.forEach((x) => {
      if (Array.isArray(x.value)) {
        x.value.forEach((y) => {
          if (Array.isArray(y.value)) {
            y.value.forEach((z) => {
              json[x.fieldName + "" + y.fieldName + z.fieldName] = z.value;
            });
          } else {
            json[x.fieldName + "" + y.fieldName] = y.value;
          }
        });
      } else {
        json[x.fieldName] = x.value;
      }
    });

    return json;
  }

  toUpdateWorkflow(newValues) {
    const selected = toJS(this.data)[0];
    selected.value.forEach((x) => {
      if (Array.isArray(x.value)) {
        x.value.forEach((y) => {
          if (Array.isArray(y.value)) {
            y.value.forEach((z) => {
              if (
                newValues.hasOwnProperty(
                  x.fieldName + "" + y.fieldName + z.fieldName
                )
              ) {
                if (
                  z.value !=
                  newValues[x.fieldName + "" + y.fieldName + z.fieldName]
                ) {
                  z.changed = true;
                }
                z.value =
                  newValues[x.fieldName + "" + y.fieldName + z.fieldName];
              }
            });
          } else {
            if (newValues.hasOwnProperty(x.fieldName + "" + y.fieldName)) {
              if (y.value != newValues[x.fieldName + "" + y.fieldName]) {
                y.changed = true;
              }
              y.value = newValues[x.fieldName + "" + y.fieldName];
            }
          }
        });
      } else {
        if (newValues.hasOwnProperty(x.fieldName)) {
          if (x.value != newValues[x.fieldName]) {
            x.changed = true;
          }
          x.value = newValues[x.fieldName];
        }
      }
    });
    this.data[0] = selected;
    this.toUpdateParent();
  }

  toUpdateParent() {
    ToolStore.toUpdate("workflowTreatement", this.getData());
  }
}

export default new WorkflowStore();
